import 'ui-core/widgets/looker/js/looker';
const looker = UX.looker;
/***
 * @DEF for sticky filters header
 * @INFO This code to watch the header and check if it doesn't have the fixed-element class then remove the class otherwise add it
 * @link https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
 */
looker.additionalSticky = () => {
    const targetStickeyHeader = document.querySelector('header .auto-hide-bar');
    const targetStickyFilter = document.querySelector('.looker__filters');

    if (targetStickyFilter && targetStickeyHeader) {
        new MutationObserver(stickyHeader => {
            const header = stickyHeader[0].target;
            if (header?.classList.contains('fixed-element')) {
                targetStickyFilter.classList.remove('sticky-looker-filter');
            } else {
                targetStickyFilter.classList.add('sticky-looker-filter');
            }
        }).observe(targetStickeyHeader, {attributes: true});
    }
};

looker.initSubmitButtons = () => {
    if ($('.looker__filters-wrapper').length) {
        let $wrapper = $('.looker__filters-wrapper'),
            wrapperWidth = $wrapper.outerWidth();
        $wrapper
            .find('.jcf-select-looker__filters__field')
            .append(
                `<div class="looker__filters__footer"><button class="btn transparent looker__filters__cancel">Cancel</button><button class="btn blue looker__filters__submit">Submit</button></div>`
            );
        $wrapper.find('.jcf-select-text').css('max-width', wrapperWidth - 40);
    }
};
